import axios from 'axios'
import interceptors from './interceptors'
import {each, merge, get} from 'lodash-es'

export default function install (Vue, { store, router, baseURL }) {
  const http = axios.create({baseURL})
  
  interceptors(http, store, router, Vue)

  http.link = (url) => {
    var token = store.getters['auth/token']
    return `${baseURL}/${url}?token=${token}`
  } 

  http.selectOptions = function(url, config) {
    config = merge({
      blankValue: true,
      blankLabel: '',
      value: 'id',
      label: 'name'
    }, config)

    return http.get(url).then(function(response) {
      var items = []

      if (config.blankValue) {
        items.push({id: undefined, name: config.blankLabel})
      }

      each(get(response, 'data.items', []), (item) => {
        items.push({id: get(item, config.value), name: get(item, config.label)})
      })

      return items
    })
  }

  Object.defineProperty(Vue.prototype, '$http', {
    get () {
      return http
    }
  })
}
